import { Row, Col, Input, Button, Form, Checkbox, Modal } from "antd";
import Icon from "@mdi/react";
import axios from "axios";
import { mdiArrowLeft } from "@mdi/js";
import { useState, useEffect } from "react";
import styled from 'styled-components';
import { useHistory, useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { namespaces } from "../../../../../i18n/i18n.constants";
import environment from "../../../../../config/environment";

const BoxSelect = styled.div`
text-align: center;
background: #f9f9f9;
border: 0.1rem solid #b3b3b3;
border-radius: 0.7rem;
padding: 1rem;`

const BoxSelectSub = styled.div`
margin-top: 2rem;
text-align: center;
color: #A6A6A6;`

const ButtonSelect = styled.div`
width: 100%;
background: #023b66;
border-radius: 50rem;
color: #fff;
cursor: pointer;
`
const ConsentSelectPage = () => {
  const location: any = useLocation()
  const history = useHistory();
  const dt = new Date();
  const [isCheckAcceptance, setIsCheckAcceptance] = useState(false);
  const [isCheckDeacceptance, setIsCheckDeacceptance] = useState(false);
  const { t } = useTranslation(namespaces.pages.daolinv);

  const consent = () =>{
    history.push({
      pathname: "/contents/daolInv/consentRMF/consent",
      state: {
        customerName: location?.state?.customerName,
        customerId: location?.state?.customerId,
        taxId: location?.state?.taxId,
        taxYear: location?.state?.taxYear,
        phoneNumber: location?.state?.phoneNumber
      },
    });
  }
  const consentBackInformation = () =>{
    history.push({
      pathname: "/contents/daolInv/consentRMF/consentBackInformation",
      state: {
        customerName: location?.state?.customerName,
        customerId: location?.state?.customerId,
        taxId: location?.state?.taxId,
        taxYear: location?.state?.taxYear,
        phoneNumber: location?.state?.phoneNumber
      },
    });
  }
  useEffect(() => {
  }, [location]);

  return (
    <>
      <div className="home-page">
        {console.log("isCheckAcceptance", isCheckAcceptance)}
        <div className="container">
          <Row className="container-main row">
            <div className="content-left col-sm-5">
              <a onClick={() => history.push("/contents/daolInv/consentRMF/otp")}>
                <Icon path={mdiArrowLeft} size="30" color="#FFFFFF" />
              </a>
              <div className="info-left">
                <p className="text-center text-header">
                  {t("consent_select_title")}
                </p>
                <p className="content-sub">
                  {t("consent_select_descrip", { year: location?.state?.taxYear})}
                </p>
              </div>
            </div>
            <div className="content-right col-sm-7">
              <p className="text-center text-header">
                {t("consent_select_descrip_header")}
              </p>
              <div className="box-consent">
                <Row>
                  <Col span={11} offset={1}>
                    <BoxSelect>
                      แจ้งความประสงค์
                      ส่งข้อมูล ปีปัจจุบัน
                      <BoxSelectSub>
                        { t("consent_select_text_invest", {year: location?.state?.taxYear})}
                        <ButtonSelect onClick={() => consent()}>คลิก</ButtonSelect>
                      </BoxSelectSub>
                    </BoxSelect>

                  </Col>
                  <Col span={11} offset={1}>
                    <BoxSelect>
                      แจ้งความประสงค์
                      ส่งข้อมูล ปีย้อนหลัง
                      <BoxSelectSub>
                      { t("consent_select_text_back_invest", {year: location?.state?.taxYear})}
                        <ButtonSelect onClick={() => consentBackInformation()}>คลิก</ButtonSelect>
                      </BoxSelectSub>
                    </BoxSelect>
                  </Col>
                </Row>
              </div>
            </div>
          </Row>
        </div>
      </div>
    </>
  );
};
export default ConsentSelectPage;
